import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DateTime from '../../admin/common/DateTime';
import Apiauth from "../../API/Apiauth.js";
import { ToastContainer } from "react-toastify";
import "../style.scss";
import "../rtlApp.scss";
import "./../../admin/common/header/header.scss";
import TableLoader from '../../admin/common/TableLoader';
import SubmenuBar from './SubmenuBar.jsx'
import DataPurge from "../common/modules/DataPurgeModal";
import { useDispatch } from 'react-redux';
import { updateIntegratedApps } from 'source/app/appSlice';
import { success } from "./helpers/toastify";

const Header = ({ Fullhandle }) => {
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const activeHeader = pathParts[3] ? pathParts[3].trim() : "inventory";
  const [dataNotificationsData, setNotifications] = useState([]);
  const [LanguageList, setLanguageData] = useState(null);
  const [loginData, setLoginData] = useState({ fname: 'user', lname: '' });
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const [CurrentLan_flg, setLanguageSelectData] = useState('US.png');
  const { t, i18n } = useTranslation();
  const [checkApiCall, setCheckApiCall] = useState(true);
  const [totalNotification, setTotalNotification] = useState(0);
  const [activeNotification, setActiveNotification] = useState('all');
  const [showAllNotifications, setShowAllNotifications] = useState(false);
  const dataFetched = useRef()
  const seenNotificationIds = useRef(new Set())
  const notificationsReady = useRef(false)
  const [dataPurge, setDatapurge] = useState(true);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   // Function to be called every 10 seconds
  //   const interval = setInterval(() => {
  //     // Call your function here
  //     getNotifications();
  //   }, 50000); // 10000 milliseconds = 10 seconds

  //   // Clear the interval when the component is unmounted
  //   return () => clearInterval(interval);
  //   // eslint-disable-next-line
  // }, []); // Empty dependency array means this effect runs only once

  const getUserData = async () => {
    setCheckApiCall(false);
    const postdata = {};
    let profileData = await Apiauth(postdata, `App/profile/get-auth`);
    if (profileData.code === 200) {
      setLoginData(profileData?.data);
      setLanguageData(profileData?.languageList);
      dispatch(updateIntegratedApps(profileData?.data?.integrations));

    }

  }


  const getNotifications = useCallback(async () => {
    try {
      const postdata = {};
      let resNotification = await Apiauth(postdata, `Inventory/common/getNotification`);
      if (resNotification.code === 200) {
        const list = resNotification.data || [];
        setNotifications(list);
        countNotification(list);
        const unread = list.filter((item) => item?.status === 0);
        if (!notificationsReady.current) {
          unread.forEach((item) => {
            if (item?.id != null) seenNotificationIds.current.add(String(item.id));
          });
          notificationsReady.current = true;
          return;
        }
        unread.forEach((item) => {
          const id = item?.id != null ? String(item.id) : "";
          if (!id || seenNotificationIds.current.has(id)) return;
          seenNotificationIds.current.add(id);
          const text = String(item?.msg || "")
            .replace(/<[^>]*>/g, " ")
            .replace(/\s+/g, " ")
            .trim();
          // Import jobs toast from notifications; sample downloads already
          // toast once in the download helper — skip duplicate sample toasts.
          if (/import/i.test(text) && !/sample/i.test(text)) {
            success(text);
          }
        });
      }
    } catch (err) {
      console.error(err, 'err');
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      getNotifications();
    }, 15000);
    return () => clearInterval(interval);
  }, [getNotifications]);

  const updateNotifications = async (itemid) => {
    try {
      const postdata = {
        "id": itemid,
        "status": 1
      };
      let resNotification = await Apiauth(postdata, `Inventory/common/updateNotification`);
      if (resNotification.code === 200) {
        getNotifications();
      }
    } catch (err) {
      console.error(err, 'err');
    }
  }

  const markAllNotificationsRead = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const unread = (dataNotificationsData || []).filter(
      (item) => item?.status === 0 && item?.id != null
    );
    if (!unread.length) return;
    try {
      await Promise.all(
        unread.map((item) =>
          Apiauth(
            { id: item.id, status: 1 },
            `Inventory/common/updateNotification`
          )
        )
      );
      getNotifications();
    } catch (err) {
      console.error(err, 'err');
    }
  };

  const viewAllNotifications = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowAllNotifications(true);
  };

  const closeNotifications = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowAllNotifications(false);
    const toggle = document.getElementById("notify");
    if (toggle && window.bootstrap?.Dropdown) {
      window.bootstrap.Dropdown.getOrCreateInstance(toggle).hide();
    }
  };

  const rtlView = useCallback((type, l) => {
    localStorage.setItem('UserLang', l);
    setLanguageSelectData(localStorage.getItem('UserLang'));
    let bodyid = document.querySelector('#body_id');
    if (type === 'rtl') {
      bodyid.classList.add('rtl');
    } else {
      bodyid.classList.remove('rtl');
    }
  }, [setLanguageSelectData]);

  useEffect(() => {
    const fetchData = async () => {
      if (checkApiCall) {
        await getUserData();
      }

      if (localStorage.getItem("UserLang")) {
        setLanguageSelectData(localStorage.getItem("UserLang"));
      } else {
        setLanguageSelectData('US.png');
      }

      if (localStorage.getItem("UserLang") === 'SA.png') {
        rtlView('rtl', localStorage.getItem("UserLang"));
      }
      if (dataFetched.current) return;
      dataFetched.current = true
      getNotifications();
    };

    fetchData();
    // eslint-disable-next-line
  }, [checkApiCall, setLanguageSelectData, rtlView]);

  const createMarkup = (html) => {
    return { __html: html };
  };
  const countNotification = (data) => {
    let totalCount = data.filter((item) => item.status === 0)
    setTotalNotification(totalCount.length)
  }

  const handleStoppingDropdownClose = (e) => {
    e.stopPropagation();
  }

  const isMentionNotification = (item) => {
    if (
      item?.type === "mention" ||
      item?.notification_type === "mention" ||
      item?.mention === 1 ||
      item?.is_mention === 1 ||
      item?.is_mention === true
    ) {
      return true;
    }
    return /@[\w.]+/.test(String(item?.msg || ""));
  };

  const visibleNotifications = (dataNotificationsData || []).filter((item) =>
    activeNotification === "mentions" ? isMentionNotification(item) : true
  );
  return (
    <>
      <ToastContainer></ToastContainer>
      <header className='main-v3-header d-flex align-items-center justify-content-between bg-white' style={{position:'sticky',top:0,zIndex:10}}>
        <div className='main-v3-header-left'>
          <span className='main-v3-header-left-name d-block name'>{t(loginData?.organization)}</span>
          <span className='main-v3-header-left-date d-block name-bottom-text'><DateTime></DateTime> </span>
        </div>
        <div className='main-v3-header-right d-flex align-items-center'>

          <div className="main-v3-header-right-country">
            <div className="dropdown">
              <button className="dropdown-toggle" type="button" id="headercountry" data-bs-toggle="dropdown" aria-expanded="false">
                <img src={base_assets + 'images/flags/' + CurrentLan_flg} alt="icon" /> <span>{t("eu")}</span>
              </button>
              <ul className="dropdown-menu" aria-labelledby="headercountry">
                {LanguageList?.map((LanguageCode, index) => (
                  <li key={index}>
                    <button
                      className="dropdown-item"
                      tabIndex="0"
                      onClick={() => {
                        i18n.changeLanguage(LanguageCode.Lan_value);
                        rtlView(
                          LanguageCode.Lan_value === 'arabic' ? 'rtl' : 'ltr',
                          LanguageCode.Lan_photo
                        );
                      }}
                    >
                      <img
                        src={base_assets + 'images/flags/' + LanguageCode.Lan_photo}
                        alt=""
                      />
                      <span>{LanguageCode.Lan_text}</span>
                    </button>
                  </li>
                ))}
              </ul>

            </div>
          </div>

          <div className=" common-dropdown notification-area">
            <button className="notification-area-btn" type="button" id="notify" onClick={() => getNotifications()} data-bs-toggle="dropdown" aria-expanded="false">
              <i className="fa fa-bell-o" aria-hidden="true"></i>
              {totalNotification > 0 ?
                <span className='notification-area-count'>
                  <span className='notification-area-count-num'>{totalNotification}</span>
                </span>
                : ""}
            </button>
            <div className="dropdown-menu" onClick={(e) => handleStoppingDropdownClose(e)}>
              <div className='notification-area-heading'>
                <div className='d-flex justify-content-between align-items-center'>
                  <span className='d-flex'>{t("Notificationss")} {totalNotification > 0 ? <div className='notification-area-heading-noti'>{t(`${totalNotification}`)}</div> : ""} </span>
                  <button
                    type="button"
                    className="notification-area-heading-menuicons"
                    aria-label={t("Close")}
                    onClick={closeNotifications}
                    style={{ border: "none", background: "transparent", cursor: "pointer", fontSize: "22px", lineHeight: 1 }}
                  >
                    ×
                  </button>
                </div>
              </div>
              <div className='tasksidebar-tabs'>
                <div
                  className="tasksidebar-tabs-inner"
                  role="tablist"
                >
                  <div className={`tasksidebar-tabs-inner-item cursor-pointer ${activeNotification === 'all' ? 'active' : ''}`} onClick={() => setActiveNotification('all')}>
                    <span className="tasksidebar-tabs-inner-item-text">
                      {t("All")}
                    </span>
                  </div>
                  <div
                    className={`tasksidebar-tabs-inner-item cursor-pointer ${activeNotification === 'mentions' ? 'active' : ''}`} onClick={() => setActiveNotification('mentions')}>
                    <span className="tasksidebar-tabs-inner-item-text">
                      {t("Mentions")}
                    </span>
                  </div>
                </div>
              </div>
              <ul
                className='notification-area-list'
                style={
                  showAllNotifications
                    ? { maxHeight: "calc(100vh - 280px)", overflowY: "auto" }
                    : undefined
                }
              >
                {visibleNotifications.length ? visibleNotifications.map((result, key) => {
                  return (
                    <li className={`notification-area-list-single ${result?.status === 0 ? 'unread' : ""}`} key={key} onClick={() => updateNotifications(result?.id)}>
                      <Link target={result?.url ? '_blank' : ""} to={result?.url ? result?.url : '#'} className='notification-area-list-single-a'>

                        <img className='notification-area-list-single-image' src={result?.image} alt="createdbyProfile" />
                        <div className='notification-area-list-single-wrapper'>
                          <span className='notification-area-list-single-text' dangerouslySetInnerHTML={createMarkup(result?.msg)}></span>
                          <div className='notification-area-list-single-foot'>
                            <span className='notification-area-list-single-foot-time'>{result?.time}</span>
                            <span className='notification-area-list-single-foot-user'>
                              {/* <i className="fa fa-user notification-area-list-single-foot-user-icon" aria-hidden="true"></i> */}
                              {result?.created_by}
                            </span>
                          </div>
                        </div>
                      </Link>
                      {result?.status === 0 ? <div className='notification-area-list-single-notificationmark'></div> : ""}
                    </li>
                  )

                }) : (
                  <div className='notification-area-list notification-area-no-notification'>
                    <span className='notification-area-no-notification-text'>
                      {activeNotification === "mentions"
                        ? t("No mentions")
                        : t("No Notifications Here")}
                    </span>
                  </div>
                )}

              </ul>
              <div className='notification-area-list-bottom'>
                <div
                  className='notification-area-list-bottom-left'
                  role="button"
                  onClick={totalNotification > 0 ? markAllNotificationsRead : undefined}
                  style={{ cursor: totalNotification > 0 ? "pointer" : "default" }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 12L11.9497 16.9497L22.5572 6.34326M2.0498 12.0503L6.99955 17M17.606 6.39355L12.3027 11.6969" stroke={`${totalNotification > 0 ? '#5CC7C1' : '#B3B3B3'}`} strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span className={`${totalNotification > 0 ? '' : 'disable'}`}>{t("Mark all as read")}</span>
                </div>
                <button
                  type="button"
                  className='notification-area-list-bottom-right'
                  onClick={showAllNotifications ? closeNotifications : viewAllNotifications}
                  style={{ cursor: "pointer" }}
                >
                  {showAllNotifications ? t("Close") : t("View all notifications")}
                </button>
              </div>
            </div>
          </div>

          <div className="common-dropdown notification-area">
            {!Fullhandle.active ? (
              <span onClick={Fullhandle.enter}>
                <svg width="15" height="15" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.7407 9.44855L23.4532 2.76054L23.4313 6.55159C23.4243 6.86764 23.6744 7.14262 23.9901 7.13558L24.3904 7.13519C24.706 7.12775 24.967 6.93961 24.9737 6.62356L24.9901 0.97611C24.9901 0.970658 24.9686 0.966355 24.9686 0.960879L24.9994 0.674556C25.0025 0.515749 24.9655 0.374152 24.8633 0.272868C24.7622 0.170777 24.6206 0.108584 24.4633 0.112887L24.1781 0.119536C24.1727 0.119536 24.1684 0.121492 24.1625 0.122299L18.5664 0.0976562C18.2511 0.104697 17.9901 0.365986 17.9831 0.682428L17.9823 1.08377C18.0303 1.45654 18.3225 1.67441 18.6378 1.66737L22.326 1.67715L15.6374 8.34199C15.3327 8.64748 15.3327 9.14267 15.6374 9.44855C15.9421 9.75365 16.4361 9.75365 16.7407 9.44855ZM8.28348 15.7468L1.57106 22.414L1.59252 18.6437C1.59994 18.3272 1.34942 18.0522 1.03417 18.0593L0.609302 18.0601C0.293266 18.0679 0.0326098 18.2556 0.025977 18.5721L0.00958994 24.2195C0.00958994 24.225 0.0310491 24.2285 0.0310491 24.2348L0.000225927 24.5203C-0.00328558 24.6791 0.0337803 24.8215 0.136394 24.922C0.237058 25.0245 0.379078 25.0863 0.535926 25.0824L0.821528 25.0754C0.826966 25.0754 0.830868 25.073 0.837135 25.073L6.45786 25.0977C6.77312 25.0898 7.03377 24.8285 7.04116 24.5125L7.04194 24.1108C6.99398 23.7388 6.70172 23.5201 6.38646 23.5272L2.69823 23.5174L9.38648 16.8533C9.6912 16.5478 9.6912 16.0527 9.38648 15.7472C9.08176 15.4417 8.58818 15.4413 8.28345 15.7468H8.28348ZM24.9905 24.2191L24.9741 18.5716C24.9671 18.2552 24.7061 18.0674 24.3908 18.0596L23.9905 18.0588C23.6749 18.0518 23.4251 18.3271 23.4318 18.6432L23.4536 22.4342L16.7408 15.7467C16.4361 15.4412 15.9421 15.4412 15.6374 15.7467C15.3327 16.0522 15.3327 16.5474 15.6374 16.8529L22.3257 23.5169L18.6378 23.5267C18.3225 23.5197 18.0303 23.7384 17.9823 24.1103L17.9831 24.512C17.9905 24.8285 18.2515 25.0898 18.5664 25.0972L24.163 25.0726C24.1688 25.0726 24.1731 25.0749 24.1786 25.0749L24.4638 25.0819C24.621 25.0858 24.763 25.024 24.8637 24.9216C24.9659 24.8206 25.0026 24.6787 24.9999 24.5199L24.9691 24.2343C24.9691 24.2281 24.9905 24.2246 24.9905 24.2191L24.9905 24.2191ZM2.69826 1.67776L6.3869 1.66806C6.70216 1.6751 6.99439 1.45684 7.04238 1.08443L7.0416 0.682746C7.03377 0.366329 6.77309 0.104624 6.45828 0.0979741L0.837135 0.122225C0.830892 0.121443 0.826991 0.119487 0.821528 0.119487L0.535926 0.112813C0.379103 0.108535 0.236692 0.170728 0.136394 0.272794C0.0337803 0.374103 -0.00326119 0.5157 0.000225927 0.674507L0.0310491 0.96083C0.0310491 0.966282 0.00958994 0.970218 0.00958994 0.976085L0.025977 6.62353C0.033 6.93959 0.293656 7.12773 0.609302 7.13516L1.03419 7.13553C1.34945 7.14257 1.59952 6.86759 1.5925 6.55154L1.57104 2.78123L8.28348 9.44841C8.58781 9.75392 9.08218 9.75392 9.38692 9.44841C9.69167 9.14289 9.69164 8.64733 9.38692 8.34184L2.69826 1.67776Z" fill="#5CC7C1" />
                </svg>

              </span>
            ) : (
              <span onClick={Fullhandle.exit}>

                <svg width="15" height="15" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <g id="fullscreen_x5F_exit">
                      <g>
                        <polygon fill="#5CC7C1" points="24.586,27.414 29.172,32 32,29.172 27.414,24.586 32,20 20,20 20,32 			" />
                        <polygon fill="#5CC7C1" points="0,12 12,12 12,0 7.414,4.586 2.875,0.043 0.047,2.871 4.586,7.414 			" />
                        <polygon fill="#5CC7C1" points="0,29.172 2.828,32 7.414,27.414 12,32 12,20 0,20 4.586,24.586 			" />
                        <polygon fill="#5CC7C1" points="20,12 32,12 27.414,7.414 31.961,2.871 29.133,0.043 24.586,4.586 20,0 			" />
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
            )}
          </div>
          <div className="main-v3-header-right-user">
            <div className="dropdown">
              <button className="dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">

                <img src={loginData?.myProfile ? loginData?.myProfile : base_assets + "images/icons/user-img.png"} alt="" />
                <div className='text-start fw-normal'>
                  <span className="main-v3-header-right-user-name name d-block">{loginData?.fname + " " + loginData?.lname}</span>
                  <span className="main-v3-header-right-user-name name-bottom-text d-block">{t(loginData?.position)}</span>
                </div>
              </button>
              <ul className="dropdown-menu main-v3-header-right-user-dropdown">
                <li> <Link className='dropdown-menu-single' to="/app/admin/profile">
                  <div className="main-v3-header-right-user-dropdown-img">
                    <i className="fa fa-user-o" aria-hidden="true"></i>
                  </div>
                  <span>{t("Profile")}</span>
                </Link>
                </li>
                {loginData?.userType === "Administrator" ?
                  <li>
                    <div className='dropdown-menu-single' data-bs-toggle="modal" data-bs-target="#dataPurgeModal" onClick={() => {
                      setDatapurge(true)
                    }}>
                      <div className="main-header-right-user-dropdown-img">
                        <i className="fa fa-database" aria-hidden="true"></i>
                      </div>
                      <span >{t("Data Purge")}</span>
                    </div>
                  </li> : ""}
                <li>
                  <Link className='dropdown-menu-single' to="/logout">
                    <div className="main-v3-header-right-user-dropdown-img">
                      <i className="fa fa-power-off" aria-hidden="true"></i>
                    </div>
                    <span>{t("logout")}</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </header>
      <DataPurge dataPurge={dataPurge} setDatapurge={setDatapurge} />
      <SubmenuBar nav="inventory" activeHeader={activeHeader} />

    </>
  )
}

export default Header;